import type { SessionEvent } from "./types"

export class EventBuffer {
  private events: SessionEvent[] = []

  constructor(private cap = 500) {}

  push(event: SessionEvent): void {
    this.events.push(event)
    if (this.events.length > this.cap) {
      this.events = this.events.slice(-this.cap)
    }
  }

  get size(): number {
    return this.events.length
  }

  take(): SessionEvent[] {
    const out = this.events
    this.events = []
    return out
  }
}
